import {Component, EventEmitter, Input, Output} from '@angular/core';
import {EventResponse} from "../../../model/response/event/event-response.model";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {ErrorMessageEnum} from "../../../enums/error-message.enum";
import {EventService} from "../../../../service/api/event.service";
import {finalize, tap} from "rxjs";
import {ApiResponse} from "../../../model/response/ApiResponse";
import {MessageToastService} from "../../../../service/message-toast.service";

@Component({
    selector: 'app-event-closure-modal',
    templateUrl: './event-closure-modal.component.html',
    standalone: false
})
export class EventClosureModalComponent {

  @Input('event') event: EventResponse
  @Input('display') displayModal: boolean

  @Output('onCloseSuccess') onCloseSuccess = new EventEmitter<any>()
  @Output('onCancelModal') onCancelModal = new EventEmitter<any>()

  form: FormGroup
  outcomeFormError: string = null
  isLoading = false;
  decisions: { code?: string, description?: string }[] =
    [{code: '', description: ''},
      {code: 'YES', description: 'Sim'},
      {code: 'NO', description: 'Não'}]

  constructor(
    private eventService: EventService,
    private messageToast: MessageToastService,
  ) {
  }

  ngOnInit(): void {
    this.form = new FormGroup({
      "outcome": new FormControl(null, Validators.required),
    });
  }

  onSubmit() {

    this.outcomeFormError = null

    if (this.form.invalid) {
      this.validateFormErrors()
    } else {
      this.isLoading = true
      this.apiTerminateAccount()
    }
  }

  apiTerminateAccount() {
    const isResolved: string = this.form.value["outcome"]
    this.eventService.terminateEvent(this.event.id, isResolved == "YES").pipe(
      finalize(() => this.isLoading = false),
      tap({
        next: value => {
          this.messageToast.success(value.message)
          this.onCloseSuccess.emit()
          this.onCancelModal.emit()
        },
        error: (err: ApiResponse<any>) => {
          this.messageToast.error(err?.message)

          if (err?.formErrors) {
            this.outcomeFormError = err.formErrors.get("isResolved")
          }
        }
      })).subscribe()
  }

  validateFormErrors() {
    if (this.form.invalid) {
      if (this.form.get("outcome")?.hasError("required")) {
        this.outcomeFormError = ErrorMessageEnum.requiredField
      }
    }
  }
}
